var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import { withBoundaries } from '../../hoc';
import { View } from 'react-native';
var GenericSectionComponent = props => {
  var children = props.children,
    _props$renderViewCont = props.renderViewContainer,
    renderViewContainer = _props$renderViewCont === void 0 ? true : _props$renderViewCont,
    restProps = __rest(props, ["children", "renderViewContainer"]);
  var Wrapper = renderViewContainer ? View : Fragment;
  return _jsx(Wrapper, Object.assign({}, renderViewContainer && restProps, {
    children: children
  }));
};
GenericSectionComponent.genericRendererKey = 'AirGenericSection';
GenericSectionComponent.isAirSection = true;
export var GenericSection = withBoundaries(GenericSectionComponent);